import axios from 'axios';
import {Message} from "element-ui";
import qs from 'qs'
import store from '../store/index'
import router from '../router'
import Vue from "vue";
axios.defaults.timeout = 6000;
import backCode from '../assets/js/code'
axios.defaults.baseURL="/simulationep";
const serverIp ="https://wh.zdzxtech.cn";
Vue.prototype.serverIp=serverIp;
Vue.prototype.errorImg = require("../assets/image/manage/sysBg.png");
/*axios.defaults.withCredentials=true;*/
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//http request 拦截器
axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem("token");
        if(token){
            config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("token");
            store.dispatch("setIfOut",false);
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    if(response.data.code==="0X00M03"){
        Message.error("登录账户数已满!");
        return
    }
    for(let i in backCode){
        if(response.data.code===i){
            if (document.getElementsByClassName('el-message').length === 0) {
                Message.error(backCode[i]);
            }
        }
    }
    return response
}, (err) => {
    if (err && err.response) {
        switch (err.response.status) {
            case 500:
                switch (err.response.data.code) {
                    case "23":
                        break;
                    case "0X01M02":
                        Message.error("账号或密码错误");
                        return;
                }
                break;
            case 400:
                break;
            case 401:
                if(!store.getters.getIfOut){
                    Message.error("登录信息已过期");
                    router.replace({
                        path: '/',
                    });
                }
                store.dispatch("setIfOut",true);
                store.dispatch("removeToken");
                break;
                /*switch (err.response.data.code) {
                    case 10004:
                        Message.error("登录信息已过期");
                        router.replace({
                            path: '/',
                        });
                        store.dispatch("removeToken");
                        break;
                    case 10005:
                        Message.error("该账号已在其他终端登录");
                        router.replace({
                            path: '/',
                        });
                        store.dispatch("removeToken");
                        break;
                }
                break;*/
            default:
                console.log(`连接错误${err.response.status}`)
        }
    } else {
        console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response);
});


/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url,params={}){
    return new Promise((resolve,reject) => {
        axios.get(url,{
            params:params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}



/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */


export function post(url,data){
    return new Promise((resolve,reject) => {
    if(navigator.appName==='Microsoft Internet Explorer'){
        let xhr = new XMLHttpRequest();
        xhr.open("POST",axios.defaults.baseURL+url, true);
        // 添加http头，发送信息至服务器时内容编码类型
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(qs.stringify(data));
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 304)) {
                resolve(JSON.parse(xhr.responseText))
            }
        };
    }
    else{
            axios.post(url,qs.stringify(data))
                .then(response => {
                    resolve(response.data);
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}



export function json(url,method,data){
    return new Promise((resolve,reject) => {
        axios({
                url: url,
                method: method,
                data: data,
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
            })
            .then(response => {
                if(response&&response.data&&response.data.code==='200'){
                    resolve(response.data);
                }
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装文件上传
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

export function upload(url,data,config){
    return new Promise((resolve,reject) => {
        axios.post(url,data,config)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}
export function download(url,data){
    return new Promise((resolve,reject) => {
        axios.post(url,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            responseType:'blob'
        })
            .then(response => {
                resolve(response);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
    return new Promise((resolve,reject) => {
        axios.patch(url,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
    return new Promise((resolve,reject) => {
        axios.put(url,data,{
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}
